<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-suitcase'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">職業</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">職業</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getJobLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>職業</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">職業の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.jobs.content">
          <v-chip
            v-for="item in getJobItems"
            :key="`jobs_content_${item.value}`"
            :value="item.value"
            :rules="rules.jobs">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.jobs.note"
          label="職業の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyJobs',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        jobs: {
          'edu-jr': '小中学生',
          'edu-hg': '高校生',
          'edu-tech': '専門学校生',
          'edu-uni': '短大・大学生',
          'employee': '社会人',
          'unemployee': 'フリーター（無職も含む）',
          'housekeeper': '主（夫/婦）業',
          'others': 'その他'
        }
      },
      form: {
        jobs: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        jobs: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.jobs
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.jobs.content && this.$props.data.jobs.content === 'NONE'))
        this.$set(this.form, 'jobs', {
          id: '' + (this.$props.data.jobs.id ? this.$props.data.jobs.id : 'new_jobs'),
          content: this.$props.data.jobs.content ? this.$props.data.jobs.content.split(',') : [],
          note: this.$props.data.jobs.note ? this.$props.data.jobs.note : ''
        })
      } else {
        this.$set(this.form, 'jobs', {
          id: 'new_jobs',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'jobs'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.jobs, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['jobs', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'jobs'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['jobs', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'jobs'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.jobs &&
        this.$props.data.jobs.content &&
        this.$props.data.jobs.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.jobs &&
        this.$props.data.jobs.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.jobs &&
        this.$props.data.jobs.note
      ) ? this.$props.data.jobs.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.jobs &&
        this.$props.data.jobs.note
      )
    },
    getJobItems () {
      return Object.keys(this.meta.jobs).map(key => {
        return {
          text: this.meta.jobs[key],
          value: key
        }
      })
    },
    getJobLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.jobs &&
        this.$props.data.jobs.content
      ) ? this.$props.data.jobs.content.split(',').map(key => {
          return (this.meta.jobs[key]) ? this.meta.jobs[key] : ''
        }) : []
    }
  }
}
</script>
